import React from 'react'
import { Link, graphql } from 'gatsby'
import Img from 'gatsby-image'
import rehypeReact from 'rehype-react'
import PropTypes from 'prop-types'

import styles from '../styles'
import Counter from '../components/Counter'
import Layout from '../layouts/blog'
import { rhythm, scale } from '../utils/typography'
import SEO from '../components/seo'

import 'katex/dist/katex.min.css'

const renderAst = new rehypeReact({
  createElement: React.createElement,
  components: { 'interactive-counter': Counter }
}).Compiler

class BlogPostRoute extends React.Component {
  render() {
    const post = this.props.data.markdownRemark

    let tags
    let tagsSection
    if (post.fields.tagSlugs) {
      const tagsArray = post.fields.tagSlugs
      tags = tagsArray.map((tag, i) => {
        const divider = i < tagsArray.length - 1 && <span>{`, `}</span>
        return (
          <span key={tag}>
            <Link to={tag}>{post.frontmatter.tags[i]}</Link>
            {divider}
          </span>
        )
      })
      tagsSection = (
        <span
          css={{
            fontStyle: `normal`,
            textAlign: `left`
          }}
        >
          tagged {tags}
        </span>
      )
    }

    return (
      <Layout location={this.props.location}>
        <SEO
          title={post.frontmatter.title}
          description={post.excerpt}
          titleTemplate={`%s | ${this.props.data.site.siteMetadata.blogTitle}`}
          isBlogPost
          postData={post}
          url={this.props.location.href}
        />
        <div
          css={{
            maxWidth: rhythm(26)
          }}
        >
          <header>
            <h1
              css={{
                marginBottom: rhythm(1 / 6),
                color: post.frontmatter.shadow
              }}
            >
              {post.frontmatter.title}
            </h1>
            <p
              css={{
                ...scale(-1 / 5),
                display: `block`,
                color: `${styles.colors.light}`
              }}
            >
              {post.timeToRead} min read &middot; {tagsSection}
            </p>
          </header>
          <h2>Contents</h2>
          <div
            dangerouslySetInnerHTML={{ __html: post.tableOfContents }}
            className="toc"
          />

          {renderAst(post.htmlAst)}
          <hr
            css={{
              marginBottom: rhythm(1),
              marginTop: rhythm(2)
            }}
          />
          <p
            css={{
              marginBottom: rhythm(4 / 4),
              display: `flex`,
              alignItems: `center`
            }}
          >
            <Img
              alt={`Avatar of ${post.frontmatter.author.id}`}
              fixed={post.frontmatter.author.avatar.children[0].fixed}
              css={{
                borderRadius: `100%`,
                mozBorderRadius: `100%`,
                float: `left`,
                marginRight: rhythm(3 / 4),
                marginBottom: 0
              }}
              Tag="span"
            />
            <span
              css={{
                color: styles.colors.light,
                ...scale(-1 / 5)
              }}
            >
              <small
                css={{
                  fontWeight: `bold`,
                  color: styles.colors.text,
                  textTransform: `uppercase`
                }}
              >
                {post.frontmatter.author.id}
              </small>
              {` `}
              {post.frontmatter.author.bio}
              <br />
              <span
                dangerouslySetInnerHTML={{
                  __html: `<a href="https://twitter.com/ateologov?ref_src=twsrc%5Etfw" class="twitter-follow-button" data-show-count="false">Follow @ateologov</a><script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>`
                }}
              />
            </span>
          </p>
        </div>
      </Layout>
    )
  }
}

BlogPostRoute.propTypes = {
  location: PropTypes.object,
  data: PropTypes.object
}

export default BlogPostRoute

export const pageQuery = graphql`
  query($slug: String!) {
    site {
      siteMetadata {
        blogTitle
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      excerpt(pruneLength: 160)
      htmlAst
      timeToRead
      tableOfContents
      fields {
        tagSlugs
      }
      frontmatter {
        title
        image
        tags
        date(formatString: "MMMM DD, YYYY")
        author {
          id
          bio
          avatar {
            children {
              ... on ImageSharp {
                fixed(width: 50, height: 50, quality: 75, grayscale: false) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`
